export default __webpack_public_path__ + "static/media/rivernew.1faaf64c.png";